module.exports = __webpack_public_path__ + "img/pc_dragon_bg.bbf35d5.webp";